import { Box, Flex, Text } from '@mantine/core'
import { IQuizLabelParameter } from '@components/text/QuizLabelParameter'
import React from 'react'
import accounting from 'accounting'

interface IQuizParameterTemplatePercent {
    label?: IQuizLabelParameter['label']
    percen: string
    value: string | number
}

const QuizParameterTemplatePercent = ({
    label = '',
    percen,
    value,
}: IQuizParameterTemplatePercent) => {
    return (
        <Flex
            style={{ borderRadius: '16px' }}
            ml={{ xs: '0', lg: 'lg' }}
            pr={0}
            justify={{ xs: 'start', md: 'space-between' }}
            align={{ lg: 'center' }}
            direction={{ xs: 'column', md: 'row' }}
        >
            <Flex
                direction={{ xs: 'column', md: 'row' }}
                justify={{ xs: 'start', md: 'space-between' }}
                gap='4px'
                miw={{ md: '450' }}
            >
                <Text c='text.2' display={{ xs: 'none', md: 'block' }}>
                    {label}
                </Text>
                <Text display={{ xs: 'none', md: 'block' }}>{percen}</Text>
                <Text c='text.2' display={{ xs: 'block', md: 'none' }}>
                    กรณีคาดหวังผลตอบแทนจากการลงทุนก่อนเกษียณ {percen}
                </Text>
            </Flex>
            <Flex gap='md' align='center'>
                <Text c='text.2' display={{ xs: 'block', md: 'none' }} miw={60}>
                    เงินลงทุน
                </Text>
                <Text c='fuchasia.4' pr='11px'>
                    {Number(value) > 0
                        ? accounting.formatMoney(value!, {
                              symbol: '',
                              precision: 2,
                          })
                        : '-'}
                </Text>
                <Box w={66} c='text.2'>
                    บาท/เดือน
                </Box>
            </Flex>
        </Flex>
    )
}

export default QuizParameterTemplatePercent
